import React, { Component } from "react";
import { Redirect } from "react-router";
import PropTypes from "prop-types";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import Alert from "@material-ui/lab/Alert";

import { COLOR_NAVY } from "../common/constants";
import Documents from "./documents";
import { HTTP } from "../../apiConfig";

const propTypes = {
  match: PropTypes.object.isRequired,
};

const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const StyledAlert = styled(Alert)`
  position: absolute;
  top: 80px;
  left: 0px;
`;

class Info extends Component {
  constructor(props) {
    super(props);
    this.verificationCodeExpirationDate = null;
    this.intervalId = null;

    this.state = {
      data: null,
      verification: null,
    };
  }

  componentDidMount() {
    const { productGuidOrCompanyId, jurId } = this.props.match.params;

    if (!Number.isNaN(Number(productGuidOrCompanyId))) {
      this.getRedirect(productGuidOrCompanyId, jurId);
      return;
    }

    this.getDocuments(productGuidOrCompanyId, jurId);

    const urlParams = new URLSearchParams(window.location.search);
    const jwt = urlParams.get("jwt");
    if (jwt) {
      this.getVerificationCode(jwt);
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  getDocuments(productGuidOrCompanyId, jurId) {
    HTTP.get(`/forms/${productGuidOrCompanyId}/`, {
      params: { jurisdictionCode: jurId },
    }).then(
      (response) => {
        if (response.status === 204) {
          this.setState({ data: [] });
        } else {
          this.setState({ redirect: false, data: response.data });
        }
      },
      () => {
        this.setState({ data: [] });
      }
    );
  }

  getRedirect(productGuidOrCompanyId, jurId) {
    HTTP.get(
      `/forms/getCompanyToProductRedirectUrl/${productGuidOrCompanyId}/`,
      { params: { jurisdictionCode: jurId } }
    ).then(
      (response) => {
        this.setState({ redirect: true, data: response.data });
      },
      () => {
        this.setState({ data: [] });
      }
    );
  }

  getVerificationCode(jwt) {
    HTTP.get("/forms/verificationCode", { params: { jwt } }).then(
      (response) => {
        this.verificationCodeExpirationDate = new Date(
          response.data.expirationDate
        );

        if (this.verificationCodeExpirationDate > new Date()) {
          const minutesToExpire = Math.floor(
            (this.verificationCodeExpirationDate - new Date()) / (1000 * 60)
          );
          this.setState({
            verification: {
              verificationCode: response.data.verificationCode,
              minutesToExpire,
            },
          });

          this.intervalId = setInterval(
            () => this.updateMinutesToExpire(),
            1000 * 15
          );
        }
      },
      () => {
        this.setState({ verification: null });
      }
    );
  }

  updateMinutesToExpire() {
    const minutesToExpire = Math.floor(
      (this.verificationCodeExpirationDate - new Date()) / (1000 * 60)
    );
    this.setState((prevState) => ({
      verification: { ...prevState.verification, minutesToExpire },
    }));
  }

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{ pathname: this.state.data.redirectUrl, state: { status: 301 } }}
        />
      );
    }

    return this.state.data ? (
      <StyledFlex>
        {this.state.verification &&
          this.state.verification.minutesToExpire > 0 && (
            <StyledAlert severity="info">
              <strong>{this.state.verification.verificationCode}</strong> is
              your verification code. It expires in{" "}
              <strong>{this.state.verification.minutesToExpire}</strong> minute
              {this.state.verification.minutesToExpire !== 1 ? "s" : ""}.
            </StyledAlert>
          )}
        <Documents items={this.state.data} />
      </StyledFlex>
    ) : (
      <StyledFlex>
        <CircularProgress
          style={{ color: COLOR_NAVY }}
          size={100}
          thickness={1}
        />
      </StyledFlex>
    );
  }
}

Info.propTypes = propTypes;
export default Info;
